"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iterator = exports.getSymbolIterator = void 0;
function getSymbolIterator() {
  if (typeof Symbol !== 'function' || !Symbol.iterator) {
    return '@@iterator';
  }
  return Symbol.iterator;
}
exports.getSymbolIterator = getSymbolIterator;
exports.iterator = getSymbolIterator();
